import { Component, OnInit, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

import { DashboardSettingService } from '../../../../core/services/dashboard-setting.service';
import { DashboardService } from './../../../../core/services/dashboard.service';
import { AuthenticationService } from './../../../../core/services/authentication.service';
import { UserService } from './../../../../core/services/user.service';

import { environment } from '../../../../../environments/environment';
import { DashboardStepperComponent } from '../../components/dashboard-stepper/dashboard-stepper.component';
import { Router } from '@angular/router';
import { ModalControlService } from 'src/app/core/services/modal-control.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    private apiUrl = environment.apiUrl;
    public modalRef: BsModalRef;
    bsModalRef: BsModalRef;
    modalCloseSub: Subscription;
    isPageLoaded: boolean = false;
    dashboardSettings: any = false;
    loginUser: any;
    dashboardLists: any;
    dashboardLists1: any;
    length = 5;
    userLists = [];
    isStepperOpen: boolean = false;

    constructor(
        public translate: TranslateService,
        private modalService: BsModalService,
        private authenticationService: AuthenticationService,
        private dashboardService: DashboardService,
        private userService: UserService,
        private dashboardSettingService: DashboardSettingService,
        private router: Router,
        private modalControl: ModalControlService,
        private renderer: Renderer2,
        private el: ElementRef
    ) {
        this.authenticationService.loginUser.subscribe(x => this.loginUser = x);
        //translate.use(this.loginUser.language);
    }

    ngOnInit() {

        this.getDashboardSettings();
        // this.getDashboardCounts(this.length);
        this.getUsers();

        const stepperPercentage = Number(localStorage.getItem('profile_status_percentage')) || 0;
        if (stepperPercentage < 80) {
            this.openStepperModal();
        }

        this.dashboardLists1 = {
            project_count_by_status: {
                all: 7,
                open: 5,
                in_progress: 1,
                on_hold: 1,
                cancel: 0,
                completed: 0
            },
            // task_count_by_status: [],
            "task_count_by_status": [
                {
                    "status": 1,
                    "total": 1,
                    "is_overdue": 0
                },
                {
                    "status": 2,
                    "total": 1,
                    "is_overdue": 0
                },
                {
                    "status": 3,
                    "total": 1,
                    "is_overdue": false
                }
            ],
            count_by_month: {
                "1": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "2": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "3": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "4": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "5": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "6": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "7": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "8": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "9": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "10": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "11": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                },
                "12": {
                    "tasks": 0,
                    "defects": 0,
                    "incidents": 0
                }
            },
            "projects": [
                {
                    "id": 7,
                    "user_id": 1,
                    "generated_id": "P00007",
                    "project_name": "Test 87",
                    "project_version": "3",
                    "client_id": 2,
                    "progress": 0,
                    "project_hours": 0,
                    "start_date": "2025-04-16",
                    "end_date": "2025-04-16",
                    "billing_type": 1,
                    "price_rate": 1500.75,
                    "estimated_hours": "80:00",
                    "actual_hours": null,
                    "status": 1,
                    "demo_url": null,
                    "description": null,
                    "project_logo": null,
                    "assign_to": null,
                    "assign_members": "Unassign",
                    "notes": null,
                    "is_overdue": 126,
                    "created_at": "2025-04-16 17:35:20",
                    "updated_at": "2025-04-16 17:35:20",
                    "deleted_at": null,
                    "pivot": {
                        "user_id": 1,
                        "project_id": 7,
                        "view": 1,
                        "edit": 1,
                        "delete": 1
                    },
                    "users": [
                        {
                            "id": 1,
                            "firstname": "Admin",
                            "lastname": "Admin",
                            "avatar": null,
                            "full_name": "Admin Admin",
                            "pivot": {
                                "project_id": 7,
                                "user_id": 1
                            }
                        }
                    ]
                },
                {
                    "id": 4,
                    "user_id": 1,
                    "generated_id": "P00004",
                    "project_name": "Test - Parth",
                    "project_version": "1.0",
                    "client_id": null,
                    "progress": 0,
                    "project_hours": 0,
                    "start_date": "2025-04-16",
                    "end_date": "2025-04-16",
                    "billing_type": null,
                    "price_rate": null,
                    "estimated_hours": null,
                    "actual_hours": null,
                    "status": 1,
                    "demo_url": null,
                    "description": null,
                    "project_logo": null,
                    "assign_to": null,
                    "assign_members": "Unassign",
                    "notes": null,
                    "is_overdue": 126,
                    "created_at": "2025-04-16 17:30:22",
                    "updated_at": "2025-04-16 17:30:22",
                    "deleted_at": null,
                    "pivot": {
                        "user_id": 1,
                        "project_id": 4,
                        "view": 1,
                        "edit": 1,
                        "delete": 1
                    },
                    "users": [
                        {
                            "id": 1,
                            "firstname": "Admin",
                            "lastname": "Admin",
                            "avatar": null,
                            "full_name": "Admin Admin",
                            "pivot": {
                                "project_id": 4,
                                "user_id": 1
                            }
                        }
                    ]
                },
                {
                    "id": 3,
                    "user_id": 1,
                    "generated_id": "P00003",
                    "project_name": "Test - Krishna",
                    "project_version": "1.0",
                    "client_id": null,
                    "progress": 0,
                    "project_hours": 0,
                    "start_date": "2025-04-16",
                    "end_date": "2025-04-16",
                    "billing_type": null,
                    "price_rate": null,
                    "estimated_hours": null,
                    "actual_hours": null,
                    "status": 1,
                    "demo_url": null,
                    "description": null,
                    "project_logo": null,
                    "assign_to": null,
                    "assign_members": "Unassign",
                    "notes": null,
                    "is_overdue": 126,
                    "created_at": "2025-04-16 17:23:51",
                    "updated_at": "2025-04-16 17:23:51",
                    "deleted_at": null,
                    "pivot": {
                        "user_id": 1,
                        "project_id": 3,
                        "view": 1,
                        "edit": 1,
                        "delete": 1
                    },
                    "users": [
                        {
                            "id": 1,
                            "firstname": "Admin",
                            "lastname": "Admin",
                            "avatar": null,
                            "full_name": "Admin Admin",
                            "pivot": {
                                "project_id": 3,
                                "user_id": 1
                            }
                        }
                    ]
                },
                {
                    "id": 2,
                    "user_id": 1,
                    "generated_id": "P00002",
                    "project_name": "Test 1",
                    "project_version": "1.0",
                    "client_id": null,
                    "progress": 0,
                    "project_hours": 0,
                    "start_date": "2025-04-16",
                    "end_date": "2025-04-16",
                    "billing_type": null,
                    "price_rate": null,
                    "estimated_hours": null,
                    "actual_hours": null,
                    "status": 2,
                    "demo_url": null,
                    "description": null,
                    "project_logo": null,
                    "assign_to": null,
                    "assign_members": "Unassign",
                    "notes": null,
                    "is_overdue": 126,
                    "created_at": "2025-04-16 17:23:26",
                    "updated_at": "2025-04-16 17:23:26",
                    "deleted_at": null,
                    "pivot": {
                        "user_id": 1,
                        "project_id": 2,
                        "view": 1,
                        "edit": 1,
                        "delete": 1
                    },
                    "users": [
                        {
                            "id": 1,
                            "firstname": "Admin",
                            "lastname": "Admin",
                            "avatar": null,
                            "full_name": "Admin Admin",
                            "pivot": {
                                "project_id": 2,
                                "user_id": 1
                            }
                        }
                    ]
                },
                {
                    "id": 1,
                    "user_id": 1,
                    "generated_id": "P00001",
                    "project_name": "Test",
                    "project_version": "1.0",
                    "client_id": null,
                    "progress": 0,
                    "project_hours": 0,
                    "start_date": "2025-04-16",
                    "end_date": "2025-04-16",
                    "billing_type": null,
                    "price_rate": null,
                    "estimated_hours": null,
                    "actual_hours": null,
                    "status": 3,
                    "demo_url": null,
                    "description": null,
                    "project_logo": null,
                    "assign_to": null,
                    "assign_members": "Unassign",
                    "notes": null,
                    "is_overdue": false,
                    "created_at": "2025-04-16 15:42:52",
                    "updated_at": "2025-04-16 15:42:52",
                    "deleted_at": null,
                    "pivot": {
                        "user_id": 1,
                        "project_id": 1,
                        "view": 1,
                        "edit": 1,
                        "delete": 1
                    },
                    "users": [
                        {
                            "id": 1,
                            "firstname": "Admin",
                            "lastname": "Admin",
                            "avatar": null,
                            "full_name": "Admin Admin",
                            "pivot": {
                                "project_id": 1,
                                "user_id": 1
                            }
                        }
                    ]
                }
            ],

        };

    }

    // openStepperModal() {
    //         const initialState = {};
    //         this.modalService.show(DashboardStepperComponent, {
    //             initialState,
    //             class: 'modal-lg modal-dialog-centered custom-blur-modal',
    //             backdrop: 'static',
    //             keyboard: false
    //         });
    // }

    openStepperModal() {
        this.isStepperOpen = true;
        this.modalControl.openStepperModal(DashboardStepperComponent);

        // Listen for close from service
        this.modalControl.modalClosed.subscribe(() => {
            this.isStepperOpen = false;
        });
    }

        // openStepperModal() {
        //     this.isStepperOpen = true;

        //     // open modal via service
        //     this.bsModalRef = this.modalService.show(DashboardStepperComponent, {
        //         class: 'modal-lg modal-dialog-centered',
        //         backdrop: 'static',
        //         keyboard: false
        //     });

        //     // unsubscribe previous listener if it exists
        //     if (this.modalCloseSub) {
        //         this.modalCloseSub.unsubscribe();
        //     }

        //     // ✅ listen for modal close
        //     this.modalCloseSub = this.modalService.onHidden.subscribe(() => {
        //         this.isStepperOpen = false;
        //     });
        // }
        ngOnDestroy() {
            if (this.modalCloseSub) {
                this.modalCloseSub.unsubscribe();
            }
        }

        getDashboardSettings() {
            this.dashboardSettingService.getAll()
                .subscribe(
                    data => {
                        this.dashboardSettings = data;
                    });
        }

        getUsers() {
            this.userService.getUserkeyBy().subscribe(data => {
                this.userLists = data;
            });
        }

        // getDashboardCounts(length) {
        // 	this.dashboardService.getDashboardCounts(length)
        // 		.subscribe(
        // 			data => {
        // 				this.dashboardLists = data;
        // 				this.getDashboardLists(this.length);
        // 			});
        // }

        // getDashboardLists(length) {
        // 	this.dashboardService.getDashboardLists(length)
        // 		.subscribe(
        // 			data => {
        // 				this.dashboardLists1 = data;
        // 				this.isPageLoaded = true;
        // 			});
        // }
    }
